import { AxiosResponse } from "axios";
import React, { useRef, useState } from "react";
import { UseMutationResult } from "react-query";
import { useAppSelector } from "../../hooks";
import useCertify from "../../hooks/useCertify";
import { CertifyInfo } from "../../types";

const CertifyForm: React.FC = () => {
    const memKey = useAppSelector(state => state.auth.memKey);
    const memName = useAppSelector(state => state.auth.memName);
    const [birth, setBirth] = useState<string>('');
    const [sex, setSex] = useState<string>('');
    const [confirm, setConfirm] = useState<string>('');
    const birthRef = useRef<HTMLInputElement>(null);
    const sexRef = useRef<HTMLInputElement>(null);
    const confirmRef = useRef<HTMLInputElement>(null);
    const mutation: UseMutationResult<AxiosResponse, Error, CertifyInfo> = useCertify();
    const certifyInfo: CertifyInfo = {
        memKey: '',
        memName: '',
        memSex: '',
        memBirth: '',
    }

    const handleBirthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBirth(e.target.value);
    }

    const handleSexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSex(e.target.value);
    }

    const handleConfirmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirm(e.target.value);
    }

    const handleCertify = (task: string) => {
        if ("save" === task) {
            if (checkValidation()) {
                certifyInfo.memKey = memKey;
                certifyInfo.memName = memName;
                certifyInfo.memSex = sex;
                certifyInfo.memBirth = birth;
                mutation.mutate(certifyInfo);
            }
        } else {
            setBirth('');
            setSex('');
            setConfirm('');
        }
    }

    const checkValidation = (): boolean => {
        if ("" !== birth && "" !== sex && "" !== confirm) {
            return true;
        } else {
            if ("" === birth) {
                alert("생년월일을 입력하여 주십시오.");
                birthRef.current?.focus();
            }

            if ("" === sex) {
                alert("성별을 선택하여 주십시오.");
                sexRef.current?.focus();
            }

            if ("" === confirm) {
                alert("본인확인여부를 선택하여 주십시오.");
                confirmRef.current?.focus();
            }
            return false;
        }
    }

    return (
        <>
            <fieldset className="space">
                <dl>
                    <dt><label htmlFor="loginName">이름</label></dt>
                    <dd><input type="text" name="loginName" id="loginName" defaultValue={memName} style={{backgroundColor: "#f1ebeb"}}/></dd>
                    <dt><label htmlFor="loginBirth">생년월일</label></dt>
                    <dd><input type="text" id="loginBirth" name="loginBirth" value={birth} ref={birthRef} onChange={handleBirthChange} /> ex)19880101</dd>
                    <dt className="wspace hspace2">성별</dt>
                    <dd className="hspace2 mt5">
                        <input type="radio" id="sex_M" name="sex" value="M" onChange={handleSexChange} ref={sexRef} checked={"M" === sex} />
                        <label htmlFor="sex_M">남자</label> 
                        <input type="radio"id="sex_F" name="sex" value="F" className="ml10" onChange={handleSexChange} checked={"F" === sex} /> 
                        <label htmlFor="sex_F">여자</label>
                    </dd>
                    <dt className="wspace hspace2">본인이 맞습니까?</dt>
                    <dd className="hspace2 mt5">
                        <input type="radio" id="confirm_Y" name="confirm" value="Y" onChange={handleConfirmChange} ref={confirmRef} checked={"Y" === confirm} /><label htmlFor="confirm_Y">예</label>
                        <input type="radio" id="confirm_N" name="confirm" value="N" className="ml10" onChange={handleConfirmChange} checked={"N" === confirm} /><label htmlFor="confirm_N">아니오</label>
                    </dd>
                </dl>
                <p className="green">타인의 정보를 무단으로 이용하는 행위는 개인정보보호법에 위반됩니다.</p>
            </fieldset>
            <div className="btn">
                <button type="button" onClick={() => handleCertify("save")} className="m gray">다음</button>
                <button type="button" onClick={() => handleCertify("reset")} className="m gray">취소</button>
            </div>
        </>
    )
}

export default CertifyForm;